module.exports = __webpack_public_path__ + "img/infoIcon.277cadd7.svg";